import Vue from 'vue'
import VueTypedJs from '../components/SearchPopup/new-design/vue-typed-js'

Vue.use(VueTypedJs)
